import { Tooltip } from "react-tooltip";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentRounded';
import SendIcon from '@mui/icons-material/SendRounded';
import BookmarkIcon from '@mui/icons-material/Bookmark';

import React, { useContext, useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { FormContext } from '../../../context/FormContext';
import FormField from '../../UI/FormField';
import ErrorText from '../../UI/ErrorText';


function ImpressionsForm() {

  const { formData, updateForm } = useContext(FormContext);

  const IMPRESSIONS_PER_FOLLOWER = 10;   // x10
  const RPM = 8.16;                      // $ per 1000 impressions (revenue per mille)

  const [local, setLocal] = useState({
    followerCount: formData.followerCount?.toString() ?? "",
  });

  // If context changes elsewhere, reflect it here
  useEffect(() => {
    const ctxVal = Number(formData?.followerCount ?? 0);
    // only update if different to avoid cursor jumps while typing
    if (!Number.isNaN(ctxVal) && ctxVal !== local.followerCount) {
      setLocal(p => ({ ...p, followerCount: ctxVal }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.followerCount]);

  const toNum = (v) => {
    const n = typeof v === 'number' ? v : Number(v);
    return Number.isFinite(n) && n >= 0 ? n : 0;
  };

  const fmtInt = (n) =>
    new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(n);

  const fmtCurrency = (n) =>
    new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(n);

  // --- derived values ---
  const count = Number(local.followerCount) || 0;
  const impressions = Math.floor(count * IMPRESSIONS_PER_FOLLOWER);
  const revenue = (impressions / 1000) * RPM;

  const MAX_FOLLOWERS = 634000000;

  // --- handlers ---
  const handleFollowersChange = (e) => {
    let raw = e.target.value;
    // strip leading zeros ("012" -> "12")
    raw = raw.replace(/^0+(?=\d)/, "");

    // clamp
    let num = Number(raw);
    if (num > MAX_FOLLOWERS) {
      num = MAX_FOLLOWERS;
      raw = String(MAX_FOLLOWERS);
    }

    setLocal(p => ({ ...p, followerCount: raw }));
    if (!Number.isNaN(num) && raw !== "") {
      updateForm?.({ followerCount: num });
    }
  };


  return (
    <>
      <div className="contents-main">
        <h1>Let's calculate your impressions.</h1>

        <p>
          Advertisers pay Meta for attention. Impressions measure how many times your posts are shown to people.
        </p>

        <div className="" style={{ marginTop: 25 }}>
          <label for="followers"><b>How many followers do you have?</b></label>
          <input
            id="followers"
            name="followers"
            type="number"
            placeholder=""
            value={local.followerCount}
            onChange={handleFollowersChange}
            style={{ marginTop: 10, outline: 'none', border: '1px solid #c7c7c7ff', borderRadius: 6, height: 35, textAlign: 'left', padding: '0 2%', width: '90%' }}
          />

        </div>
        
        <p style={{fontSize: 13, color: 'grey'}}>
          On average, 1 follower = 3 impressions per month.
        </p>
      </div>

      <div className="contents-footer">
        <p className="footer-label">Total Impressions</p>
        <p className="footer-value">{local.followerCount*3}</p>
      </div>
    </>
  );
}
export default ImpressionsForm;